import {BaseApi} from '@/common/api/BaseApi';
import {ApiVersionProperties} from '@/types/common/api/api.types';

export class CommonApi {

  public static countries({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/countries`;
  }

  public static logo(): string {
    return `${BaseApi.ROOT_URL}/logo`;
  }

  public static loginLogo(): string {
    return `${BaseApi.ROOT_URL}/login-logo`;
  }

  public static footerLinks({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/footer-links`;
  }

  public static socialMedia({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/social-media`;
  }

  public static partnerShop({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/partner-shops`;
  }

}
